/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import KImage from '@/types/KImage'

class EstimatedCostsSection {
  private json: any;
  public readonly uid: string;
  public readonly estimateType: string;
  public readonly estimatedCostText: string;
  public readonly yourSelectionText: string;
  public readonly savingsText: string;
  public readonly editButtonText: string;
  public readonly restartButtonText: string;
  public readonly productsImages: Array<KImage>

  constructor (json: any) {
    this.json = json
    this.uid = json.uid
    this.estimateType = json.estimate_header
    this.estimatedCostText = json.estimatedcost
    this.yourSelectionText = json.selection_header
    this.savingsText = json.your_savings
    this.editButtonText = json.edit_selections
    this.restartButtonText = json.restart
    this.productsImages = json.images_for_products.map((image: any) => {
      const { url, content_type: type } = image.product_icon
      return new KImage(url, type, image.alt_text_icon)
    })
  }

  static of (json: any): EstimatedCostsSection {
    return new EstimatedCostsSection(json)
  }
}

export default EstimatedCostsSection
